const navigation = {
    // Main Navigation
    dashboard: 'Dashboard',
    apiProductsAutomations: 'API Products & Automations',
    customers: 'Customers',
    customerBilling: 'Customer Billing',
    analytics: 'Analytics',
    documentation: 'Documentation',
    customerPreview: 'Customer Preview',
    florentinBilling: 'Billing',
    settings: 'Settings',
    helpSupport: 'Help & Support',
    
    // User Menu
    organization: 'ORGANIZATION',
    account: 'ACCOUNT',
    agencyOrganization: 'Agency Organization',
    manageMembers: 'Manage members',
    profile: 'Profile',
    billingPlan: 'Billing & Plan',
    language: 'Language',
    supportCenter: 'Support Center',
    apiDocumentation: 'API Documentation',
    logout: 'Log out',
    
    // Plan Info
    growthPlan: 'Growth Plan',
    planDetails: '{{price}}/month + {{fee}} fees',
    admin: 'ADMIN',
    
    // Provider Info
    providerAccount: 'Provider Account',
    billingLabelSuffix: 'Billing',
  } as const;

export default navigation;
